
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
import { IDatasource} from "../../../server/src/ai/interface/IDatasource";
import { remove_table_prefix } from "../../../server/src/ai/interface/DatasourceLib";
import { Datasource,  } from "../../../server/src/ai/interface/Datasource";
import { DragManager, typeDatasourceParam } from "./DragManager";

const bus: Bus = new Bus().getBus();



@Component({ components: { } })
export default class DatasourceVue extends Vue {
  key = 0;
  listkey=0;
  dskey=0;
  dm=DragManager.getInstance()
  remove_prefix=remove_table_prefix

  datasources: IDatasource[] =[];
  list:IDatasource[] = []
  ds:IDatasource = new Datasource()

  selected_id: string =""


  async mounted() {
    this.list = await bus.api("/api/ai/datasource/getDatasources", {user: bus.get_user()} );
    this.key++
  }

  chg() {
    this.$emit('datasources_changed',{})
    this.key++
  }

  async table_create(event: MouseEvent) {
    
    event.preventDefault();
    event.stopPropagation();
    
    const ds1:any= await bus.api("/api/ai/datasource/table_create", {user: bus.get_user(), ds:this.ds} );
    if (ds1.errors.length) { alert(ds1.errors.join('\n')); return; }

    this.list = await bus.api("/api/ai/datasource/getDatasources", {user: bus.get_user()} );
    this.ds = new Datasource()
    this.key++
  }


  async table_drop(ds: IDatasource, event: MouseEvent) {
    const obj:any= await bus.api("/api/ai/datasource/table_op", {user: bus.get_user(), op:"DROP", ds:ds} );
    if (obj.errors.length) { alert(obj.errors.join('\n')); return; }
    const ds1:IDatasource= await bus.api("/api/ai/datasource/del", {user: bus.get_user(), obj:ds} );
    this.list = await bus.api("/api/ai/datasource/getDatasources", {user: bus.get_user()} );
    this.key++
  }

  async reset() {
      this.ds = new Datasource()
      this.selected_id = ""
      this.key++
  }

  set_ds(ds:IDatasource, event: MouseEvent) {
    event.stopPropagation()
    event.preventDefault()

    if ((event.button === 2)) this.copyDefinition(ds, event);
    else {
      this.ds = ds
      this.selected_id = ds.id ? ds.id : ""
      this.listkey++
    }

  }

  copyDefinition(ds: IDatasource, event: MouseEvent) {
    this.dm.set(ds, typeDatasourceParam )
    const names=[]
    for (let f of ds.fields) names.push(f.name)
    let ds_text=ds.name+": "+names.join(", ")
    this.dm.show_tooltip(ds_text, event.clientX-10, event.clientY+10 )
  }

  resizeTextarea(id: any, expand:boolean, event: MouseEvent) {
    console.log('resizeTextarea', expand)

    event.stopPropagation()

    const textarea = document.getElementById(id); // Select all textareas with the specified class
    

    if (expand) {
      this.dm.hide_tooltip()    
      this.dm.reset(typeDatasourceParam )
      const textareas = document.querySelectorAll('.resize') as any;
      textareas.forEach((textarea: { style: { height: string; }; }) => {textarea.style.height = '40px';});
      if (textarea) (<any>textarea).style.height = '160px';
    } else {
      if ((event.button === 2)) {
        event.preventDefault()
        const v=textarea?(<any>textarea).value:""
        this.dm.set({text: v, key:id, value: v}, typeDatasourceParam )
        this.dm.show_tooltip(id+ (textarea?': '+v.toString():""), event.clientX-10, event.clientY+10 )
      } else {
        this.dm.hide_tooltip()    
        this.dm.reset(typeDatasourceParam )
      }
      const textareas = document.querySelectorAll('.resize') as any;
      textareas.forEach((textarea: { style: { height: string; }; }) => {textarea.style.height = '40px';});
    }
  }

}
